// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@vanmeter/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { orderTotalDisplayStyles } from "@vanmeter/Overrides/Components/OrderTotalDisplay";

orderTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer
};
orderTotalDisplayStyles.subtotalLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.subtotalValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.discountsLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.discountsValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.shippingAndHandlingLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.shippingAndHandlingValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.otherChargesLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.otherChargesValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.otherChargesValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.taxLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.taxValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.totalLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};
orderTotalDisplayStyles.totalValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
orderTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};
orderTotalDisplayStyles.titleText = {
    ...orderTotalDisplaySharedStyles.titleText,
};
orderTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};
orderTotalDisplayStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
